{
    "tJAOh": {
        "position": {
            "x": 15,
            "y": 13,
            "z": 1
        },
        "affiliation": "bad",
        "key": "tJAOh",
        "maxhealth": "50"
    }
}